import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { IPartnerResponse } from '../models/partner.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Gets a list of partners
 * 
 * @returns {object} the api response
 */
const GetPartners = async (): Promise<IPartnerResponse> => {
    try {
      apiRetry(awsApiInstance);

      const { userId, accessList } = useAuth()!;
      const partnerIdList = accessList?.map((element: any) => element.id).join(',');

      const { data } = await awsApiInstance.get('/partners', {
          params: {
            wpId: userId,
            partnerID: partnerIdList
          }
      });

      return data;
    } catch ( error ) {
      handleRouteError(error, 'Error getting partner data');
      throw(error);
    } 
}

export default GetPartners;